import { useNavigate } from "react-router-dom";
import { Stack, Button, Container } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { FormManagementTable } from "../../component/FormManagementTable";
import "../../component/FormManagementTable/FormManagementTable.css";
import {
  isFromEditForm,
  isFromEditFormData,
} from "../../redux/Reducers/AdminFormManagementReducer";
import { useDispatch } from "react-redux";
import { strings, paths } from "../../utils/constants";
import { useRef } from "react";

export default function FormManagementPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableRef = useRef(null);

  const addFormHandler = () => {
    dispatch(isFromEditForm(false));
    dispatch(isFromEditFormData({}));
    navigate(paths.adminRoutes.EDIT_FORM);
  };
  return (
    <>
      <Container style={{ width: "80%", marginRight: "4%" }}>
        <Stack direction="row" justifyContent="end" gap={1}>
          <Button
            variant="contained"
            className="fbutton"
            startIcon={<FileDownloadIcon />}
            onClick={() => tableRef.current?.handleExport()}
          >
            {strings.words.EXPORT}
          </Button>
          <Button
            variant="contained"
            className="fbutton"
            startIcon={<AddIcon />}
            onClick={addFormHandler}
          >
            {strings.general.ADD_NEW}
          </Button>
        </Stack>
      </Container>
      <FormManagementTable ref={tableRef} />
    </>
  );
}
